<div class="forgot-wrapper">
  <div class="forgot-box card shadow">
    <div class="card-body">
      <!-- Step 1: Email Entry -->
      <ng-container *ngIf="flagswitch === 'email'">
        <div class="reset-password-header d-flex align-items-center mb-4">
          <button
            class="back-button me-3"
            mat-icon-button
            (click)="disableflag(false)"
            aria-label="Go back"
          >
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <h4 translate class="reset-title m-0 flex-grow-1 text-center">
            Reset Your Password
          </h4>
        </div>

        <p class="text-center text-muted">
          Enter your registered email to receive an OTP
        </p>
        <form [formGroup]="emailform" (ngSubmit)="onSubmitemailID()">
          <div class="mb-3">
            <label translate for="email">Email address</label>
            <input
              formControlName="useremailid"
              type="email"
              class="form-control"
              [ngClass]="{
                'is-invalid': submitted && femailform['useremailid'].errors
              }"
              placeholder="Enter your email"
            />
            <div
              *ngIf="submitted && femailform['useremailid'].errors"
              class="invalid-feedback d-block"
            >
              <div translate *ngIf="femailform['useremailid'].errors['required']">
                Email is required
              </div>
              <div transalte *ngIf="femailform['useremailid'].errors['email']">
                Enter a valid email
              </div>
            </div>
          </div>
          <ng-container *ngIf="error_message">
            <div class="custom-alert alert-danger">
              <div class="alert-content">
                <mat-icon class="alert-icon">error_outline</mat-icon>
                <div class="alert-message">
                  <p class="text-danger text-center mb-3">
                    {{ error_message }}
                  </p>
                </div>
                <button
                  type="button"
                  class="alert-close"
                  aria-label="Close"
                  (click)="emailerror = false"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </ng-container>

          <button translate type="submit" mat-flat-button color="primary" class="w-100">
            Send OTP
          </button>
        </form>
      </ng-container>

      <!-- Step 2: Verify OTP -->
      <ng-container *ngIf="flagswitch === 'verify'">
        <div class="mb-3 d-flex align-items-center">
          <button mat-icon-button (click)="flagmaintance('email')" class="me-2">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <h5 translate class="mb-0">Verify OTP</h5>
        </div>
        <p class="text-center text-muted">
          <span translate>Verification code sent to </span><b>{{ emailform.value.useremailid }}</b>
        </p>

        <form
          [formGroup]="verificationform"
          (ngSubmit)="onSubmitverification()"
        >
          <div class="mb-3">
            <label translate for="otp">Verification Code</label>
            <input
              formControlName="verification_code"
              type="text"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  submitted && fverificationform['verification_code'].errors
              }"
              placeholder="Enter OTP"
            />
            <div *ngIf="submitted && fverificationform['verification_code'].errors" class="invalid-feedback d-block">
              <div translate *ngIf="fverificationform['verification_code'].errors['required']">
                OTP is required
              </div>
            </div>
          </div>

          <button translate type="submit" mat-flat-button color="primary" class="w-100">
            Verify
          </button>
        </form>
      </ng-container>

      <!-- Step 3: Reset Password -->
      <ng-container *ngIf="flagswitch === 'password'">
        <div class="mb-3 d-flex align-items-center">
          <button mat-icon-button (click)="flagmaintance('email')" class="me-2">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <h5 translate class="mb-0">Create New Password</h5>
        </div>
        <p transalte class="text-center text-success">
          Email verified. Now set your new password.
        </p>

        <form
          [formGroup]="passwordresetform"
          (ngSubmit)="onSubmitpasswordreset()"
        >
          <div class="mb-3">
            <label translate>New Password</label>
            <input
              formControlName="password"
              type="password"
              class="form-control"
              [ngClass]="{
                'is-invalid': submitted && fpasswordresetform['password'].errors
              }"
              placeholder="Enter new password"
            />
            <div
              *ngIf="submitted && fpasswordresetform['password'].errors"
              class="invalid-feedback d-block"
            >
              <div transalte *ngIf="fpasswordresetform['password'].errors['required']">
                Password is required
              </div>
              <div transalte *ngIf="fpasswordresetform['password'].errors['minlength']">
                Minimum 6 characters required
              </div>
              <div
                *ngIf="
                  fpasswordresetform['password'].errors['passwordStrength']
                "
              >
                {{ fpasswordresetform["password"].errors["passwordStrength"] }}
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label translate>Re-enter Password</label>
            <input
              formControlName="reenter_password"
              type="password"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  submitted && fpasswordresetform['reenter_password'].errors
              }"
              placeholder="Re-enter new password"
            />
            <div *ngIf="submitted && fpasswordresetform['reenter_password'].errors" class="invalid-feedback d-block">
              <div translate *ngIf="fpasswordresetform['reenter_password'].errors['required']">
                Please re-enter your password
              </div>
            </div>
          </div>

          <button translate type="submit" mat-flat-button color="primary" class="w-100">
            Update Password
          </button>

          <div translate class="mt-4 text-center text-muted small">
            Contact Admin if you're unable to reset your password.
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</div>
